import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { getLoggedInUserThunk } from '@/state/auth/thunk/get-logged-in.thunk'
import { DialogsEnum } from '@/enums'
import { BRAND } from './api.routes'

import { SaveBrandsPayload } from '../models'
import ActionTypes from '../constants'

const restApiService: RestApiService = Container.get(RestApiService)

const saveBrandThunk = createAsyncThunk(
  ActionTypes.SAVE_BRAND,
  async (payload: SaveBrandsPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'POST',
        endpoint: BRAND.BRANDS_ADD,
        body: payload,
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      const response: any = await restApiService.sendAuthData(auth.token)

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('brand')}`,
        what: i18n.t('messages.created'),
      })

      if (response.statusCode && response.statusCode === 400) {
        message =
          typeof response.message === 'string' || response.message.length > 0
            ? response.message[0] || response.message
            : i18n.t('messages.errorOccurred')
        thunkAPI.dispatch(setLoadingFullAction(false))
      } else {
        thunkAPI.dispatch(getLoggedInUserThunk())
        thunkAPI.dispatch(
          setDialogAction({
            open: false,
            id: DialogsEnum.DIALOG_BRAND_FORM,
          }),
        )
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.statusCode && response.statusCode === 400
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

export default saveBrandThunk
